export default "__VITE_ASSET__CGq7ZmMz__"